import { createAction } from '@reduxjs/toolkit'

import { RootState } from '../index'

export const rehydrateStore = createAction<Partial<RootState>>('@PERSIST/rehydrate')
